module.exports = __webpack_public_path__ + "kw.60886a1a224114082444.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/kw.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/kw.svg
// module chunks = styles